import { MarketSortOption } from '@/constants/sort';
import { ReqGetBestProducts } from '@/service/market/best/getBestProducts';

export const RQBestKey = {
  bestHomeProducts: ['main', 'best'] as const,
  bestPageProducts: (query: ReqGetBestProducts['query'], sortOption: MarketSortOption | null) =>
    ['best', query, sortOption] as const,
};
